export default {
    lang: "zh_cn",
    //登录
    loginIn: '欢迎登录',
    logout: '退出',
    leaderManage: '集团公司后台管理',
    phoneormail: '请输入手机或邮箱',
    mail: '请输入邮箱',
    phone: '请输入手机号码',
    vcode: '请输入验证码',
    rememberaccount: '记住账号密码',
    loginSub: '登录',
    sendphonemail: '手机或邮箱必须输入',
    errorphonemail: '格式有误',
    phoneRequired: '手机号码必须输入',
    mailRequired: '邮箱必须输入',
    emailLogin: '邮箱登录',
    phoneLogin: '手机登录',
    send: '获取',
    area: '所属国家',
    selectArea: '请选择所属国家',
    visitor: '游客',
    agentMember: '平台交易会员',
    trader: '平台交易员',
    changeCancel: '转取消',
    goToComplete: '转完成',
    cancelInfo: '是否确认取消?',
    reload: '请重新加载',
    yz: '亚洲',
    oz: '欧洲',
    fz: '非洲',
    bm: '北美洲',
    nm: '南美洲',
    dy: '大洋洲',
    nj: '南极洲',
    description: '转账账号',
    selectPhoneorEmail: '仅需要输入手机号码或邮箱地址其中一种',
    voucher: '交易凭证',
    voucherPreview: '交易凭证预览',
    transact: '交易方式',
    transactTime: '交易时间',
    reason: '失败原因',
    ruleName: '请输入2-16位的数字或字母组合',

    msg1: '账户名必须输入',
    msg2: '密码必须输入',
    msg3: '验证码必须输入',
    msg4: '请先输入正确的手机或邮箱',
    msg5: '验证码发送成功',
    msg6: '当前语言',
    msg7: '当前时区',
    msg8: '请选择地区号',
    //手动提现
    manual: '手动提现数',
    manual1: '模糊查询',
    manual2: '请输入会员/商户账号/订单号',
    manual3: '手动提现',
    manual4: '创建日期',
    manual5: '选定商户',
    manual6: '选定会员',
    manual7: '请输入会员名称',
    manual8: '请选择支付方式',
    manual9: '支付详情',
    manual10: '取消订单',
    manual11: '提交订单',
    manual12: '请选择拒绝原因',
    manual13: '故障重审',
    manual14: '请输入提现金额',
    manual15: '请确认是否提交订单?',


    //差额值设置
    differenceTitle: '差额值设置',
    differenceValue: '会员利润差额值',
    differenceTip: '请输入差额值',
    //提现提成查询
    percentage: '等级',
    percentage1: '总额',
    percentage2: '本时段提成总额',
    percentage3: '本时段提成笔数',
    percentage4: '累计提成总额',
    percentage5: '累计提成笔数',
    percentage6: '精确搜索',
    percentage7: '或',
    percentage8: '提现会员',
    percentage9: '提成额',
    percentage10: '提成时间',
    percentage11: '详细信息',
    percentage12: '提成详情',
    //提现通道列表
    channel: '通道类型',
    channel1: '通道状态',
    channel2: '在线状态',
    channel3: '所属会员',
    channel4: '所属分公司',
    channel5: '会员状态',
    channel6: '会员余额',
    channel7: '通道最小值',
    channel8: '专属通道',
    channel9: '是',
    channel10: '否',
    channel11: '成功次数',
    channel12: '死码次数',
    channel13: '通道总数',
    channel14: '开启总数',
    channel15: '关闭总数',
    //提现订单查询
    withdraw: '本时段提现总额',
    withdraw1: '本时段提现笔数',
    withdraw2: '累计提现总额',
    withdraw3: '累计提现笔数',
    withdraw4: '请输入账户名或订单号',
    withdraw5: '查询',
    withdraw6: '会员等级',
    withdraw7: '操作时间',
    withdraw8: '提现详情',
    withdraw9: '会员提额审批记录',
    withdraw10: '会员累计提额总额',
    withdraw11: '会员本时段提额总额',
    withdraw12: '请输入账户名称或订单号(包括第三方)',
    //会员提额审批
    limit: '提额额度',
    limit1: '申请提额次数',
    limit2: '提额详情',
    limit3: '提升额度',
    limit4: '时间',
    limit5: '是否确认通过提额？',
    limit6: '是否确认拒绝提额？',
    //会员管理
    edituser: '账号:',
    edituser1: '名称:',
    edituser2: '全部下级(个)',
    edituser3: '所属公司',
    edituser4: '专属服务',
    edituser5: '专属商户',
    edituser6: '直属下线',
    edituser7: '直属下线详情',
    edituser8: '下线名称',
    edituser9: '人',
    edituser10: '提现通道信息',
    edituser11: '二维码',
    edituser12: '不可操作',
    edituser13: '删除提示',
    edituser14: '是否删除会员',
    edituser15: '及其下级会员',
    edituser16: '删除成功',
    edituser17: '新增专属服务',
    edituser18: '新增专属会员',
    edituser19: '新增专属分公司',
    edituser20: '是否删除该账号?',
    //个人中心
    myuser: '基本信息',
    myuser1: '修改资料',
    myuser2: '完成修改',
    myuser3: '取消修改',
    myuser4: '集团公司账号',
    myuser5: '集团公司名称',
    myuser6: '主货币',
    myuser7: '电子邮箱',
    myuser8: '下层信息',
    myuser9: '下级类型',
    myuser10: '数量',
    myuser11: '费率类型',
    myuser12: '费率数值',
    myuser13: '总公司账号',
    myuser14: '总公司名称',
    myuser15: '支持货币/余额信息',
    myuser16: '账户总额',
    myuser17: '支持通道/费率信息',
    myuser18: '额度详情',
    myuser19: '商户代理账号',
    myuser20: '商户代理名称',
    myuser21: '商户流量购买比例',
    myuser22: '流量比例',
    myuser23: '请输入数字或小数',
    myuser24: '其他货币',
    myuser25: '其他提成',
    myuser26: '我的通道',
    myuser27: '费率信息',
    myuser28: '我的通道',
    myuser29: '提成率',
    myuser30: '其它费率',
    myuser31: '费率值',
    myuser32: '员工账号',
    myuser33: '员工名称',
    myuser34: '修改邮箱',
    myuser35: '请再次输入新的邮箱',
    myuser36: '未设置邮箱，请联系集团公司',
    myuser37: '请输入新的邮箱',
    myuser38: '邮箱输入不一致',
    myuser39: '修改电话',
    myuser40: '请完善电话信息',

    //员工
    employee1: '员工数量',
    employee2: '请输入员工账号',
    employee3: '添加员工',
    employee4: '员工账号',
    employee5: '员工名称',
    employee6: '角色类型',
    employee7: '电话号码',
    employee8: '编辑',
    employee9: '登录账号',
    employee10: '编辑员工资料',
    employee11: '邮箱地址格式错误',
    //银行
    bank: '银行个数',
    bank1: '添加新银行',
    bank2: '编号',
    bank3: '银行本国名称',
    bank4: '详细名称',
    bank5: '类型排序',
    bank6: '添加银行类型',
    bank7: '修改银行类型',
    bank8: '请输入银行简称',
    bank9: '请输入详细名称',
    bank10: '银行卡个数',
    bank11: '添加新银行卡',
    bank12: '银行账号',
    bank13: '每日限额',
    bank14: '每周限额',
    bank15: '每月限额',
    bank16: '银行类型',
    bank17: '银行网点',
    bank18: '确认删除该银行卡?',
    bank19: '请确认删除?',
    bank20: '添加银行卡',
    bank21: '修改银行卡',
    bank22: '请输入账号',
    bank23: '国家',
    bank24: '银行英文名称',
    bank25: '是否开启',
    bank26: '最近一次修改人',
    bank27: '无',
    bank28: '获取失败，请重试',
    bank29: '未查询到符合条件的数据，请重新选择',
    bank30: '请输入银行网点信息',
    bank31: '请输入账户名称',
    bank32: '请输入银行账号',
    bank33: '银行卡支付',
    bank34: '流量控制收款通道',
    bank35: '全球理财收款通道',
    bank36: '广告推流收款通道',
    bank37: '本币理财收款通道',
    bank38: '添加收款通道',
    bank39: '修改收款通道',
    bank40: '新增收款通道',
    bank41: '请选择收款通道类型',
    bank42: '扫码转账',
    bank43: '数字货币转账',
    bank44: '交易所平台',
    bank45: '链名称通道',
    bank46: '收款钱包地址',
    bank47: '数字货币名称',
    bank48: '收款邮箱',
    bank49: '扫码类型',
    bank50: '请输入交易平台',
    bank51: '请输入收款钱包地址',
    bank52: '请选择收款二维码',
    bank53: '请输入收款邮箱',
    bank54: '请输入收款账号',
    bank55: '请输入扫码类型',
    bank56: '请输入正确收款钱包地址,必须包含英文字母、数字和冒号',
    bank57: '清除',
    bank58: '转账数量',
    bank59: '银行卡类型',
    bank60: '全球理财',
    bank61: '本币理财',
    bank62: '广告推流',
    bank63: '流量控制',
    bank64: '收款银行地址',
    bank65: '收款银行所在国家',
    bank66: '收款银行代码',
    bank67: '收款人地址',
    bank68: '银行-国家-分行代码',
    bank69: '请输入收款银行地址',
    bank70: '请输入收款银行所在国家',
    bank71: '请输入收款银行代码',
    bank72: '请输入收款人地址',
    bank73: '银行卡状态已开启，无法修改',
    bank74: '数字货币充值通道',
    bank75: '转账资料未填写完整',
    bank76: '数币充值',
    bank77: '扫码收款账号',

    //角色
    role: '角色',
    role1: '请输入角色名字',
    role2: '查询',
    role3: '新增',
    role4: '角色名字',
    role5: '权限',
    role6: '新增',
    role7: '角色名字不能为空',
    role8: '菜单必须输入',
    role9: '将删除角色，是否继续?',
    role10: '角色删除成功',
    role11: '将删除所选角色，是否继续?',
    //菜单
    menu: '菜单',
    menu1: '请输入菜单名字',
    menu2: '标题',
    menu3: '路径',
    menu4: '图标',
    menu5: '顺序',
    menu6: '启用',
    menu7: '设置时显示',
    menu8: '子菜单',
    menu9: '添加',
    menu10: '集团公司',
    menu11: '分公司',
    menu12: '商代',
    menu13: '总公司',
    menu14: '添加子菜单',
    menu15: '标题不能为空',
    menu16: '路径不能为空',
    menu17: '图标不能为空',
    menu18: '修改子菜单',
    menu19: '将删除所选菜单，是否继续?',
    menu20: '菜单删除成功',
    menu21: '名称',
    menu22: '时',
    menu23: '刷新',
    menu24: '全踢出',
    menu25: '分',
    menu26: '登录时间',
    menu27: '在线时间',
    menu28: '登录IP/归属地',
    menu29: '登录方式/来源',
    menu30: '秒',
    menu31: '天',
    menu32: '踢出',
    menu33: '是否下线该用户?',
    menu34: '操作成功',
    menu35: '是否下线全部用户?',

    //兑换
    exchange: '是否启用现金支付兑换功能？',
    exchange1: '启用',
    exchange2: '不启用',
    exchange3: '(下级将无法使用)',
    exchange4: '未开启任何货币',
    exchange5: '洲际选择',
    exchange6: '已选国家',
    exchange7: '展开选择',
    exchange8: '省份选择',
    exchange9: '市级选择',
    exchange10: '（点击选择）',
    exchange11: '国家列表',
    exchange12: '省份列表',
    exchange13: '批量开启/单选下级',
    exchange14: '点击选择',
    exchange15: '点击重选',
    exchange16: '是否启用筹码支付兑换功能？',
    exchange17: '会所选择',
    exchange18: '新增会所',
    exchange19: '会所名称',
    exchange20: '会所状态',
    exchange21: '请输入会所名称',
    exchange22: '您确认要删除该会所吗?',
    exchange23: '删除确认',
    exchange24: '是否启用数字支付兑换功能？',
    exchange25: '数字货币',
    exchange26: '新增平台',
    exchange27: '平台名称',
    exchange28: '已添加数字货币',
    exchange29: '请输入平台名称',
    exchange30: '请选择数字货币',
    exchange31: '您确认要删除该平台吗?',
    exchange32: '城市列表',
    exchange33: '等值',
    exchange34: 'USD以下形成派单',
    exchange35: '平台代理会员',
    exchange36: '所选城市现有',
    exchange37: '位平台代理会员',
    exchange38: '所选城市不存在平台代理会员',
    //货币汇率
    currency1: '法定货币个数',
    currency2: '数字货币个数',
    currency3: '请输入货币名称',
    currency4: '添加货币',
    currency5: '货币代码',
    currency6: '国家名称',
    currency7: '相对汇率',
    currency8: '货币代码',
    currency9: '主货币',
    currency10: '修改完本页请先保存，再进行下一页操作',
    currency11: '新增法定货币',
    currency12: '修改法定货币',
    currency13: '请输入货币代码',
    currency14: '请输入国家名称',
    currency15: '确认删除该货币?',
    currency16: '请确认删除?',
    currency17: '添加数字货币',
    currency18: '货币名称',
    currency19: '新增数字货币',
    currency20: '修改数字货币',
    currency21: '货币符号',
    currency22: '法定货币',

    loading: '加载中...',
    WECHAT_PAY: '微信扫码',
    ALI_PAY: '支付宝扫码',
    CREDIT_PAY: '微信点赞码',
    PERSONAL_BANK_PAY: '个人银行转账',
    ENTERPRISE_BANK_PAY: '企业银行转账',
    CLOUD_FLASH_PAY: '云闪付支付',
    PAYPAL_PAY: 'PayPal',
    ZALO_PAY: 'Zalo Pay',
    UPI_PAY: 'Upi',
    MER_UNMATCH: '匹配失败',
    BANK_PAY: '银行转账',
    SCAN_PAY: '扫码提现',
    MER_PENDING: '处理中',
    MER_SUCCESS: '已完成',
    MER_CANCEL: '取消单',


    MER_FAULT: '故障单',
    MER_FAULTDONE: '故障完成',
    MER_PROCESS: '待支付',
    MER_RETRIAL: '已重审',
    ALL: '全部',
    SOLD: '已卖出',
    WAITING: '待处理',
    SUCCESS: '已完成',
    REJECTED: '已拒绝',
    BEARING: '计息中',
    FREEZE: "冻结中",
    vip: '会员',
    vvip: '高级会员',
    l1: '一级会员',
    l2: '二级会员',
    l3: '三级会员',
    BRANCHROBING: '分公司抢单中',
    FAULT: '故障单',
    FAULTDONE: '故障已完成',
    company: '分公司',
    merchant: '商户',
    merchantAgent: '商户代理',
    employee: '员工',
    companyAgent: '总公司',
    enable: '开启',
    disable: '关闭',
    FREEZE_WAITING: '冻结待审批',
    FREEZE_SUCCESS: '冻结成功',
    FREEZE_REJECTED: '冻结拒绝',
    UNFREEZE_SUCCESS: '解冻成功',
    UNFREEZE_WAITING: '解冻待审批',
    VIPROBING: '会员抢单中',
    VIPPAYING: '会员付款中',
    CANCEL: '取消单',
    fddh: '货币兑换率',
    wtdh: '委托兑换率',
    hkdh: '汇款兑换率',
    qqlc: '对冲货币理财',
    xylc: '幸运理财',
    lcze: '理财总额',
    djje: '冻结金额',
    interest: '公司派息',
    register: '注册',
    globalBonus: '对冲货币理财',
    remittanceFault: '汇款故障',
    financial: '幸运理财',
    payorderMER_PROCESS: '处理中',
    bonus: '提现提成',
    payorderMER_FAULTDONE: '故障完成单',
    payorderMER_CANCEL: '取消单',
    payorderautoMER_CANCEL: '超时自动取消',
    DEPOSITSUCCESS: '普通上分',
    legal: '货币兑换',
    remittance: '汇款',
    luckBonus: '幸运理财',
    entrust: '委托兑换',
    depositRemittance: '公司抢单充值',
    payorderMER_RETRIAL: '重审',
    payorderMER_SUCCESS: '成功',
    commission: '手续费',
    saleFinance: '卖出理财',
    WITHDRAWWAITING: '提现',
    REMITTANCE: '汇款',
    entrustWAITING: '委托兑换',
    startPlaceholder: '开始日期',
    endPlaceholder: '结束日期',
    ConditionalScreening: '条件筛选',
    FindDate: '查找日期',
    CurrencyType: '货币类型',
    BaseCurrency: '主货币',
    PleaseSelect: '请选择',
    currency: '货币',
    Rate: '汇率',
    WithdrawalOrderNo: '提现订单号',
    WithdrawalBank: '提现银行',
    WithdrawalScore: '提现金额',
    WithdrawalAmount: '提现分额',
    Amount: '金额',
    ApplicationDate: '申请日期',
    Operation: '操作',
    Details: '详情',
    WithdrawalCurrency: '提现货币',
    BankAccount: '银行账户',
    BankCardNumber: '银行卡号',
    BankName: '银行名称',
    NameOfPayBank: '支付银行',
    VerificationCode: '验证码',
    Close: '关闭',
    Submit: '提交',
    Remarks: '备注',
    ApplicationTime: '申请时间',
    Reviewer: '审核人',
    AuditTime: '审核时间',
    CaptchaInformation: '验证码已发送，请注意查收',
    SubmitSuccess: '提交成功',
    addCompany: '添加分公司',
    Information: '资料信息',
    BranchAccount: '分公司账号',
    LoginPassword: '登录密码',
    BranchName: '分公司名称',
    WithdrawalChannelControl: '提现通道控制',
    CurrencyTypes: '外币开关设置',
    RoyaltyRate: '提成率',
    ReviseSucceed: '修改成功',
    ReviseFail: '修改失败',
    Revise: '修改',
    globalFinancial: '对冲货币理财',
    commonFinancial: '普通理财',

    setAvatar: '设置头像',
    avatarSetted: '头像设置成功',
    avatarSettedError: '头像设置失败',
    chooseAgain: '请重新选择',
    freezeName: '申请人',

    selectImage: '选 择 图 片',
    avatarPreview: '头 像 预 览',
    updateimage: '更 换 图 片',
    imageTips: '图片不可大于',
    imageTypeTip: '图片类型必须是',
    imageTypeTip2: '中的一种',

    selectBank: '请选择银行',
    deleteSucced: '删除成功',
    deleteFail: '删除失败',

    matchCur: '匹配货币',
    setUp: '设置',
    drainagePersonName: '引流人',
//电影
    movie: {
        selectMovieUp: '选择电影上传',
        updateMovie: '编辑电影',
        upTipTitle: '温馨提醒',
        upTip1: '1.请勿上传色情或者违法反动视频',
        upTip2: '2.请使用星际网上上传视频，表示默认同意我们的',
        movieAgreement: '内容协议',
        movieOver: '封面',
        updateOver: '修改封面',
        fileName: '文件名',
        recommendedArea: '推荐区',
        movieDistrict: '电影区',
        fontCount: '字数：5-100字',
        upMovieSuccess: '视频上传成功！正在转码.....',
        movieMsgTitle: '您刚上传视频信息',
        movieOverImg: '预览图',
        movieTitle: '标题',
        movieTag: '标语',
        movieType: '分类',
        movieAddress: '位置',
        movieIntroduction: '简介',
        movieUp: '继续上传',
        againUp: '重新上传',
        release: '发布'

    },
    addMer: {
        nextStep: '下一步',
        back: '上一步',
        addtitle: '添加商户资料',
        addBranchAgentTitle: '新增总公司',
        addMerchantAgentTitle: '添加商户代理资料',
        uptitle: '修改商户资料',
        shtitle: '审核商户资料',
        titleDetail: '商户资料详情',
        agentAccount: '代理账号',
        agentName: '代理名称',
        dataSettings: '资料设置',
        channelSettings: '通道设置',
        rateSettings: '费率设置',
        merchantType: '商户类型',
        merchantAccount: '商户账号',
        currencyType: '货币类型',
        password: '登录密码',
        merchantName: '商户名称',
        phone: '联系电话',
        accountLimit: '账户额度',
        email: '邮箱地址',
        domainName: '域名',
        role: '角色权限',
        key: '密钥',
        platformInfo: '平台信息',
        largestSingleGold: '入金单笔最大',
        merchantKey: '商户密钥',


        WechatCode: '微信扫码',
        AlipayCode: '支付宝扫码',
        wechatLikeCode: '微信赞赏码',
        PersonalBankTransfer: '个人银行转账',
        CorporateBankTransfer: '企业银行转账',

        wechatPayment: '微信支付',
        alipayPayment: '支付宝支付',
        bankpayment: '银行支付',
        cloudPayment: '云闪付支付',
        personalBank: '个人银行',
        corporateBank: '企业银行',
        scanPayment: '扫码支付',


        open: '开启',
        close: '关闭',
        currencyTypes: '外币开关设置',
        optionalCurrency: '可选择货币',
        OptionalCurrencys: '可选货币',
        opened: '已开启',
        openedCurrency: '已开启货币',
        depositServiceRate: '提现提成率',
        rujinServiceRate: '入金手续费率',
        dailiServiceRate: '代理手续费率',
        dailiOtherRate: '代理其他費率',
        agencyRate: '我的提成率',
        myRate: '我的费率',
        profitRate: '我的盈利率',
        otherRate: '其他费率',
        statutoryExchange: '货币兑换',
        entrustedExchange: '委托兑换',
        remittance: '汇款',
        remittanceExchange: '汇款',
        luckFinancing: '幸运理财',
        globalFinancing: '对冲货币理财',
        myHandRate: '我的手续费率',
        myOtherRate: '我的其他费率',
        remittanceServe: '汇款服务费',

        luckFinancingRate: '幸运理财收益率',
        globalFinanceRate: '对冲货币理财收益率',
        LegalCurrencyExchange: '货币兑换',
        EntrustedOrderExchange: '委托兑换',
        RemittanceServiceRate: '汇款手续费率',
        legal: '法币兑法币',
        legalDigit: '法币兑数币',
        digit: '数币兑数币',
        digitLegal: '数币兑法币',
        digitalLegal: '数币兑法币',

        cancel: '取 消',
        determine1: '确 定',
        prevPage: '上一页',
        nextPage: '下一页',
        adopt: '通 过',
        refuse: '拒 绝',
        merchant: '商户',
        vvip: '高级会员',

        checkBranchAccount: '请输入总公司账号',
        checkBranchType: '请选择分公司类型',
        checkBranchName: '请输入分公司名称',
        checkBranchComAgent: '请输入总公司名称',

        checkAccount: '请输入商户账号',
        checkPassword: '请输入密码',
        checkName: '请输入商户名称',
        checkphone: '请输入联系电话',
        checkAccountLimit: '请输入账户额度',
        checkEmail: '请输入邮箱地址',
        checkTrueEmail: '请输入正确的邮箱地址',
        checkUserType: '请选择商户类型',
        checkCurrId: '请选择货币类型',
        checkRole: '请选择角色权限',

        EmailError: '邮箱格式错误',
        LuckRateError: '请设置正确的幸运理财收益率',
        legalRateError: '请设置正确的法定货币兑换率',
        EntrustRateError: '请设置正确的委托指令兑换率',
        RemittanceRateError: '请设置正确的汇款手续汇率',

        whether: '是否',
        passageway: '通道',
        passageways: '通道信息',
        Tips: '提示',
        determine: '确定',
        cancel1: '取消',
        statusUpSuccess: '状态更新成功',
        statusUpFail: '状态更新失败',
        account: '账户',
        openCurrencyCheck: '是否开启当前货币?',
        closeCurrencyCheck: '是否关闭当前货币?',
        openSuccessfully: '开启成功',
        closeSuccessfully: '关闭成功',
        confirmationApproval: '确认通过审批',
        rejectionApproval: '确认拒绝审批',
        checkPass: '审批确认',
        approved: '审批已通过',
        rejected: '审批已拒绝',
        addSuccess: '添加成功',
    },

    approvalList1: '待审批商户',
    approvalList2: '商户代理',
    approvalList3: '已审批商户',
    approvalList4: '条件筛选',
    approvalList5: '用户类型',
    approvalList6: '全部',
    approvalList7: '高级会员',
    approvalList8: '商户',
    approvalList9: '分公司',
    approvalList11: '请选择',
    approvalList10: '货币类型',
    approvalList12: '请输入用户名',
    approvalList13: '用户账号',
    approvalList14: '用户名称',
    approvalList15: '用户类型',
    approvalList16: '代理名称',
    approvalList17: '用户货币',
    approvalList18: '其他币种',
    approvalList19: '联系方式',
    approvalList20: '审批时间',
    approvalList21: '申请时间',
    approvalList22: '完成时间',
    approvalList23: '审批状态',
    approvalList24: '已完成',
    approvalList25: '已拒绝',
    approvalList26: '待审批',
    approvalList27: '审核商户代理资料',
    approvalList28: '资料信息',
    approvalList29: '通道设置',
    approvalList30: '费率设置',
    approvalList31: '确认关闭',
    approvalUpCom1: '上级账号',
    approvalUpCom2: '分公司账号',
    approvalUpCom3: '账号额度',
    approvalUpCom4: '货币类型',
    approvalUpCom5: '分公司名称',
    approvalUpCom6: '联系电话',
    approvalUpCom7: '邮箱',
    approvalUpCom8: '域名',
    approvalUpCom9: '登录密码',
    approvalUpCom10: '角色权限',
    approvalUpCom11: '外币开关设置',
    approvalUpCom12: '已开启货币',
    approvalUpCom13: '可选择货币',
    approvalUpCom14: '已开启',
    guanbi: '关闭',
    kaiqi: '开启',
    approvalUpCom15: '提成率',
    approvalUpCom16: '代理费率',
    approvalUpCom17: '微信扫码',
    approvalUpCom18: '支付宝扫码',
    approvalUpCom19: '微信点赞码',
    approvalUpCom20: '个人银行转账',
    approvalUpCom21: '企业银行转账',
    approvalUpCom22: '云闪付支付',
    approvalUpCom23: '其他费率',
    approvalUpCom24: '货币兑换',
    approvalUpCom25: '委托兑换',
    approvalUpCom26: '汇款手续费率',
    approvalUpCom27: '幸运理财收益率',

    tongguo: '通过',
    jujue: '拒绝',
    approvalUpCom28: '请选择角色权限',
    approvalUpCom29: '确认通过审批？',
    approvalUpCom30: '审批确认',
    queding: '确定',
    quxiao: '取消',
    approvalUpCom31: '审批通过',
    approvalUpCom32: '审批失败',
    approvalUpCom33: '确认拒绝审批？',
    approvalUpCom34: '审批拒绝',
    approvalUpCom35: '成功',
    approvalUpCom36: '状态更新成功',
    approvalUpCom37: '关闭成功',
    approvalUpCom38: '开启成功',
    approvalUpCom39: '对冲货币理财收益率',
    approvalUpCom40: '修改总公司资料',
    approvalUpCom41: '代理提成率',
    approvalUpCom42: '审核商户资料',
    approvalUpCom43: '查看分公司资料',
    approvalUpCom44: '查看商户资料',

    applyList1: '待审批商户',
    applyList2: '已审批商户',
    applyList3: '待审批商户代理',
    applyList4: '已审批商户代理',
    applyList5: '条件筛选',
    applyList6: '商户类型',
    applyList7: '请选择',
    applyList8: '全部',
    applyList9: '高级会员',
    applyList34: '商户',
    applyList10: '货币类型',
    applyList11: '请输入用户名',
    applyList12: '添加新商户',
    applyList13: '添加新分公司',
    applyList14: '商户账号',
    applyList15: '商户名称',
    applyList16: '商户类型',
    applyList17: '分公司账号',
    applyList18: '分公司名称',
    applyList19: '货币',
    applyList20: '其他币种',
    applyList21: '联系方式',
    applyList22: '创建时间',
    applyList23: '审批状态',
    applyList33: '操作',
    applyList24: '已完成',
    applyList25: '处理中',
    applyList26: '已拒绝',
    applyList27: '详情',
    applyList28: '修改总公司资料',
    applyList29: '资料信息',
    applyList30: '通道设置',
    applyList31: '费率设置',
    applyList32: '确认关闭？',

    withdrawManage1: '商户提现申请表',
    withdrawManage2: '商户累计提现总额',
    withdrawManage3: '商户本时段提现总额',
    withdrawManage4: '审核状态',
    withdrawManage5: '开户行',
    withdrawManage6: '清空',
    withdrawManage7: '提现分额',
    withdrawManage8: '备注信息',
    withdrawManage9: '电话/邮箱',
    withdrawManage10: '登录名',
    withdrawManage11: '提现分数',
    withdrawManage12: '提现前余分',
    withdrawManage13: '累计提现',
    withdrawManage14: '拒绝原因',
    withdrawManage15: '提现申请表',
    withdrawManage16: '累计提现总额',
    withdrawManage17: '本时段提现总额',

    agentList1: '全部代理',
    agentList2: '接入数量最多',
    agentList3: '接入商户最多',
    agentList4: '总盈利最高',
    agentList5: '请输入代理名',
    agentList6: '总盈利',
    agentList7: '盈利',
    agentList8: '接入数',
    agentList9: '分公司管理',
    OpenState: '开启状态',
    AgentType: '代理类型',
    OtherCurrency: '其他币种',
    AccountBalance: '账户余额',
    BalanceDetails: '余额详情',
    CurrencyHeld: '持有币种',
    Balance: '余额',
    FinancialDetails: '理财详情',
    State: '状态',
    SuperiorAccount: '上级名称',
    Unbound: '未绑定',
    Complete: '完成',
    ChannelCategory: '通道类别',
    CommissionRate: '手续费率',

    settlement1: '代理提现审批记录',
    settlement2: '代理累计提现总额',
    settlement3: '代理当日提现总额',
    settlement4: '提现代理账户',
    settlement5: '已审批',
    settlement6: '未审批',
    settlement7: '修改代理资料',
    settlement8: '修改商户代理资料',
    PlsAccount: '请输入账户名',
    Export: '导出',
    CurrentState: '当前状态',
    TransactionNO: '交易单号',
    WithdrawalAccount: '提现账户',
    WithdrawalName: '提现名称',
    UpperScore: '上分',
    Remainder: '余分',
    CheckReject: '拒绝确认',
    RejectReason: '请输入拒绝原因',
    Input30Max: '最多输入30字',
    RejectedSuccessfully: '拒绝成功',
    ThroughSuccess: '通过成功',
    ThroughConfirmation: '通过确认',
    title1: '新增分公司',
    title2: '分公司理财审批记录',
    title3: '分公司幸运充值记录',
    title4: '分公司累计理财总额',
    title5: '分公司当天理财总额',


    company1: '分公司个数',
    company2: '理财总额最高',
    company3: '提现总额最高',
    company4: '下线最多',
    company5: '分公司状态',
    company6: '所有下线',
    company7: '银行卡',
    company8: '修改分公司资料',
    company9: '银行卡信息',
    company10: '账号类别',
    company11: '账户名称',
    company12: '户名',
    company13: '卡号',
    company14: '通道开关',
    company15: '是否开启通道?',
    company16: '是否关闭通道?',
    company17: '交易单号',
    company18: '账户名',
    company19: '分公司账户名',
    company20: '充值银行',
    company21: '充值金额',
    company22: '兑换汇率',
    company23: '充值分数',
    company24: '充值当前账户余额',
    company25: '分公司充值审核',
    company26: '货币(汇率)',
    company27: '收款银行名称',
    company28: '收款银行卡号',
    company29: '收款银行账户',
    company30: '充值前账户余额',
    company31: '提现申请',
    company32: '选择货币',
    company33: '请选择货币',
    company34: '存款金额',
    company35: '实际分值',
    company36: '收款账户',
    company37: '充值确认',
    company38: '上分成功',
    company39: '操作成功，请等待处理',
    company40: '抢单单号',
    company41: '抢单',
    company42: '抢单详情',
    company43: '开户银行',
    company44: '交易截图',
    company45: '放弃',
    company46: '订单超时',
    company47: '抢单成功，请等待处理',
    company48: '本币理财',
    company49: '外币理财',
    company50: '奖励金额',
    company51: '总公司提成率',
    company52: '总公司其他费率',
    company53: '抢单会员',

    deposit1: '本时段入金手续费总额',
    deposit2: '本时段入金笔数',
    deposit3: '累计入金手续费总额',
    deposit4: '累计入金笔数',
    deposit5: '请输入用户名或订单号',
    deposit6: '入金金额',
    deposit7: '手续费金额',
    deposit8: '收款时间',
    deposit9: '交易状态',
    deposit10: '故障单号',
    deposit11: '处理金额',
    deposit12: '故障单详情',
    deposit13: '收款金额',
    deposit14: '截图',
    deposit15: '实际金额',
    deposit16: '请输入实际金额',
    deposit17: '处理完成',
    deposit18: '重审完成',
    deposit19: '冻结资金总额',
    deposit20: '冻结资金笔数',
    deposit21: '订单号查询',
    deposit22: '新增冻结',
    deposit23: '申请人',
    deposit24: '冻结申请人',
    deposit25: '解冻申请人',
    deposit26: '冻结审核人',
    deposit27: '解冻审核人',
    deposit28: '冻结时间',
    deposit29: '解冻时间',
    deposit30: '冻结状态',
    deposit31: '冻结通过',
    deposit32: '冻结拒绝',
    deposit33: '申请解冻',
    deposit34: '解冻成功',
    deposit35: '解冻拒绝',
    deposit36: '新增冻结资金',
    deposit37: '申请',
    deposit38: '冻结确认',
    deposit39: '解冻确认',
    deposit40: '申请成功',
    deposit41: '本时段入金总额',
    deposit42: '累计入金总额',
    deposit43: '入金汇率',
    deposit44: '入金时间',
    deposit45: '激活',
    deposit46: '催单',
    deposit47: '收款货币',
    deposit48: '收款方式',
    deposit49: '收款账号',
    deposit50: '收款二维码',
    deposit51: '失败原因',
    deposit52: '收款银行',
    deposit53: '收款卡号',
    deposit54: '处理时间',
    deposit55: '激活成功',
    deposit57: '催单成功',
    deposit56: '激活确认',
    deposit58: '催单确认',
    deposit59: '入金货币',

    deposit60: '入金账号',
    deposit61: '入金分额',
    deposit62: '入金二维码',
    deposit63: '入金银行',
    deposit64: '入金卡号',

    deposit65: '本时段充值总金额',
    deposit66: '本时段充值笔数',
    deposit67: '累计充值总额',
    deposit68: '累计充值笔数',
    deposit69: '充值方式',
    deposit70: '充值费率',
    deposit71: '充值时间',
    deposit72: '充值分额',
    deposit73: '充值账号',
    deposit74: '充值二维码',
    deposit75: '充值卡号',
    deposit76: '本时段充值手续费总额',
    deposit77: '累计充值手续费总额',
    deposit78: '接口日志',


    exchane1: '新增兑换',
    exchane2: '货币余额详情',
    exchane3: '兑出详情',
    exchane4: '兑出货币',
    exchane5: '兑得货币',
    exchane6: '兑出金额',
    exchane7: '兑得信息',
    exchane8: '兑换利率',
    exchane9: '兑得金额',
    exchane10: '区域选择',
    exchane11: '选择洲际',
    exchane12: '选择国家',
    exchane13: '选择省份',
    exchane14: '选择城市',
    exchane15: '金额币种',
    exchane16: '当前选择',
    exchane17: '区域',
    exchane18: '收款人联系方式',
    exchane19: '收款人证件资料',
    exchane20: '密码验证',
    exchane21: '手机号或邮箱',
    exchane22: '点击获取',
    exchane23: '平台货币',
    exchane24: '平台账号',
    exchane25: '本时段兑换总额',
    exchane26: '本时段兑换手续费总额',
    exchane27: '本时段兑换次数',
    exchane28: '累计兑换总额',
    exchane29: '累计兑换手续费总额',
    exchane30: '累计兑换次数',
    exchane31: '累计兑换次数',
    exchane32: '兑换订单号',
    exchane33: '兑换方式',
    exchane34: '兑换金额',
    exchane35: '手续金额',
    exchane36: '兑换时间',
    exchane37: '兑换日期',
    exchane38: '兑换货币',
    exchane39: '兑换数字货币',
    exchane40: '兑换筹码',
    exchane41: '收款人选择区域平台',
    exchane42: '收款人选择区域',
    exchane43: '兑得数字货币金额',
    exchane44: '收款人平台账号',
    exchane45: '自己',
    exchane46: '是否拒绝?',
    exchane47: '精密搜索',
    exchane48: '或',
    exchane49: '兑换订单号',
    exchane50: '兑换详情',
    exchane51: '钱包地址',
    exchane52: '协议',
    exchane53: '二维码',

    onLine: '在线',
    offLine: '离线',
    VipManagement: '会员管理',
    shanchu: '删除',
    UpdateVipDetail: '修改会员资料',
    CashExchange: '现金支付兑换',
    ChipExchange: '筹码支付兑换',
    NumberExchange: '数字货币兑换',
    pls1: '请输入订单号',
    pls2: '请输入故障订单号',
    pls3: '请输入提现单号',
    pls4: '请输入故障原因',
    pls5: '请选择兑换类型',
    pls6: '请选择兑出货币',
    pls7: '兑出货币不能和兑得货币相同',
    pls8: '请选择兑得货币',
    pls9: '兑得货币不能和兑出货币相同',
    pls10: '请选择区域',
    pls11: '请选择省份',
    pls12: '请选择城市',
    pls13: '该货币余额不足，请重新输入',
    pls14: '请选择会所',
    pls15: '请选择平台',
    pls16: '信息有误，请检查',
    pls17: '请输入订单号、用户账号',

    UserName: '用户名称',
    loglout: '退出',
    PaymentMethod: '支付方式',
    OrderAmount: '订单金额',
    vipType: '会员类型',
    Handle: '处理',
    Retrial: '重审',
    vipAccount: '会员账号',
    vipName: '会员名称',
    Declare: '申报',
    FaultReason: '故障申报原因',
    FaultImg: '故障截图',
    FaultImgDetail: '截图详情',
    WithdrawalNo: '提现单号',
    WithdrawalType: '提现方式',
    Handler: '处理人',
    Date: '日期',
    addFault: '新增故障单',
    FaultOrder: '故障订单号',
    OrderStatus: '订单状态',
    OldOrder: '原订单号',
    UserAccount: '用户账号',
    OrderNo: '订单号',
    CustomerType: '用户类型',
    DepositMethod: '入金方式',
    UserNickname: '用户昵称',
    companyNickName: '分公司名称',
    ThematicCurrency: '主货币',
    UsableCurrency: '可用外币',
    Subsuperior: '所属上级',
    TotalFinancial: '理财总额',
    TotalWithdrawal: '提现总额',
    NewApply: '新增申请',
    NewWithDraw: '新增提现',
    ViewDetails: '查看详情',
    LoadingPaymentData: '加载支付资料',
    Loaded: '已加载成功',
    checkAmount: '请输入正确金额',
    PayeeAccount: '收款人账号',
    PayeeName: '收款人名称',
    MaxFiles5: '最多选择5个文件',
    MaxFiles1: '最多选择1个文件',
    UploadSuccessful: '上传成功',
    UploadFailed: '上传失败，请检查网络',

    product1: '新建产品',
    product2: '修改产品',
    product3: '产品名称',
    product4: '产品货币',
    product5: '回报周期',
    product6: '可购买会员',
    product7: '起投金额',
    product8: '年化计算率',
    product9: '一日收益',
    product10: '三日收益',
    product11: '七日收益',
    product12: '请选择回报周期',
    product13: '请输入产品名称',
    product14: '累计派息总额',
    product15: '当前计息理财总额',
    product16: '请输入订单号、产品编号或用户账号',
    product17: '产品编号',
    product18: '购买数量',
    product19: '产品周期',
    product20: '累计计息',
    product21: '卖出',
    product22: '时间',
    product23: '计息',
    product24: '卖出确认',
    product25: '卖出成功',
    product26: '产品个数',
    product27: '购买次数最多',
    product28: '请输入产品编号或产品名称',
    product29: '创建人',
    product30: '天',
    product31: '购买次数',
    product32: '理财产品购买审核记录',
    product33: '累计计息理财总额',
    product34: '年化率',
    product35: '新增对冲货币理财',
    product36: '修改时间',
    product37: '产品类型',
    product38: '商户理财',
    product39: '对冲货币理财',
    product40: '新增理财产品',
    product41: '商户理财产品',
    product42: '购买最大值',


    companyFinancial: '总公司理财',
    product43: '可以使用分公司',
    product44: '转换金额',
    product45: '合计金额',
    product46: '手续金额',
    product47: '集团理财产品',
    product48: '7天',
    product49: '30天',
    product50: '60天',
    product51: '90天',
    product52: '活期',
    product53: '计息中不可以删除',

    merchant1: '商户流量购买审批记录',
    merchant2: '商户累计购买流量总额',
    merchant3: '商户本时段购买流量总额',
    merchant4: '购买流量前额度',
    merchant5: '购买流量额度',
    merchant6: '现有账户流量',
    merchant7: '提额成功',
    merchant8: '专属会员',
    merchant9: '请输入要添加的专属会员名称',
    merchant10: '增加',
    merchant11: '序号',
    merchant12: '查看',
    merchant13: '专属会员详情',
    merchant14: '添加时间',
    merchant15: '服务笔数',
    merchant16: '服务总额',
    merchant17: '专属通道开关',
    merchant18: '您确认要删除会员',
    merchant19: '是否增加新专属会员',
    merchant20: '商户个数',
    merchant21: '入金金额最高',
    merchant22: '汇款兑换总额最高',
    merchant23: '联系方式',
    merchant24: '购买次数',
    merchant25: '提额详情',
    merchant26: '提升额度',
    merchant27: '是否确认通过提额',
    merchant28: '是否确认拒绝提额',
    merchant29: '商户提现审批记录',
    merchant30: '商户累计提现总额',
    merchant31: '本时段商户提现总额',
    merchant32: '购买流量金额',
    merchant33: '流量购买比例',
    merchant34: '购买详情',
    merchant35: '流量货币',
    merchant36: '专属分公司',
    merchant37: '请输入要添加的专属分公司名称',
    merchant38: '专属会员通道',
    merchant39: '专属分公司详情',
    merchant40: '专属分公司通道',
    merchant41: '请输入要添加的专属分公司名称',
    merchant42: '是否增加新专属分公司',
    merchant43: '您确认要删除分公司',
    merchant44: '请输入购买流量额度',
    merchant45: '购买支付货币',
    merchant46: '请输入购买流量额度',
    merchant47: '购买流量额度需大于1000',
    merchant48: '展开设置',
    merchant49: '是否添加旗下所有会员?',
    merchant50: '流量余额',
    merchant51: '所属商代',
    merchant52: '所属总公司',
    merchant53: '查询所属上级',

    DelSuccess: '删除成功',
    remit1: '本时段汇款总额',
    remit2: '累计汇款总额',
    remit3: '累计汇款次数',
    remit4: '汇款单号',
    remit5: '汇款信息',
    remit6: '汇款金额',
    remit7: '汇款分额',
    remit8: '确认收款',
    remit9: '详细汇款资料',
    remit10: '账号',
    remit11: '汇款前余额',
    remit12: '累计汇款',
    remit13: '收款银行',
    remit14: '收款户名',
    remit15: '收款账号',
    remit16: '取款货币',
    remit17: '货币余额',
    remit18: '银行网点',
    remit19: '下分分数',
    remit20: '汇款手续费率',
    remit21: '手机邮箱验证',
    remit22: '请输入手机号或者邮箱',
    remit23: '请输入验证码',
    remit24: '成功',
    remit25: '收款成功',
    remit26: '重新获取',
    remit27: '秒重试',
    remit28: '发送成功,该信息有可能被拦截，请仔细查看',
    remit29: '请输入收款银行',
    remit30: '请输入收款账号',
    remit31: '请输入收款卡号',
    remit32: '请输入正确的下分分数',
    remit33: '汇款人名称',
    remit34: '汇款人账号',
    remit35: '新增汇款',
    remit36: '汇款货币',
    remit37: '汇款分额',
    remit38: '实际汇款金额',
    remit39: '汇出分额',

    OperationMode: '操作方式',
    report1: '本时段提成总额',
    report2: '本时段费率支出总额',
    report3: '本时段操作笔数',
    report4: '累计提成总额',
    report5: '累计费率支出总额',
    report6: '累计操作笔数',
    report7: '精确查找',
    report8: '请输入订单号、名称',
    report9: '客户名称',
    report10: '商户入金',
    report11: '会员提现',
    report12: '订单时间',
    report13: '代理客户交易总额',
    report14: '代理客户费率盈亏总额',
    report15: '代理客户交易笔数',
    report16: '请输入订单号、账号、名称',
    report17: '客户账号',
    report18: '会员兑换',
    report19: '会员汇款',
    report20: '会员幸运理财',
    report21: '分公司派息总额',
    report22: '交易金额',
    report23: '交易费率',
    report24: '分公司',
    report25: '暂无数据，请选择需要查看的分公司',
    report26: '累计入金',
    report27: '充值',
    report28: '累计提现',
    report29: '抢单充值',
    report30: '提现',
    report31: '手续费盈亏',
    report32: '账号余额',
    report33: '提现及应付金额',
    report34: '会员入金总额',
    report35: '会员提现总额',

    report36: '会员汇款总额',
    report37: '会员幸运理财总额',
    report38: '会员兑换总额',
    report39: '会员费率盈亏总额',
    report40: '会员账号余额',
    report41: '会员可提现总额',

    report42: '分公司充值总额',
    report43: '分公司抢单充值总额',
    report44: '分公司费率盈亏总额',
    report45: '分公司账号余额',
    report46: '分公司应付现金',

    report47: '集团公司',
    report48: '商户入金总额',
    report49: '会员及分公司盈亏总额',
    report50: '集团公司账上余额',

    report51: '公司账户额度',
    report52: '会员累计购入理财总额',
    report53: '会员累计提现总额',
    report54: '会员委托兑换总额',
    report55: '会员汇款总额',
    report56: '会员兑换汇款总额',

    report57: '会员提现提成',
    report58: '会员兑换汇款手续费总额',
    report59: '会员累计费率盈亏总额',
    report60: '理财余额',
    report61: '账号余额',
    report62: '会员理财及账号余额',

    report63: '普通充值',
    report64: '抢单充值',
    report65: '公司累计充值总额',
    report66: '提成总额',
    report67: '派息总额',
    report68: '公司累计盈亏总额',
    report69: '操作类型',
    report70: '账户额度变化',
    report71: '公司提现提成',
    report72: '会员货币兑换',
    report73: '会员委托兑换',
    report74: '公司充值',
    report75: '收款',
    report76: '入金',
    report77: '合计',

    report78: '商户汇款总额',
    report79: '商户提现、委托兑换总额',
    report80: '商户费率盈亏总额',
    report81: '分/商代理',
    report82: '代理汇款总额',
    report83: '代理提现、委托兑换总额',
    report84: '代理费率盈亏总额',
    report85: '商户、代理及会员提现、兑换总额',
    report86: '集团公司利润总额',

    report87: '币种',
    report88: '入金总额',
    report89: '账户提现总额',
    report90: '账户汇款总额',
    report91: '委托方式',
    report92: '账户委托兑换总额',
    report93: '手续费总额',
    report94: '计息总额',
    report95: '账号费率盈亏总额',
    report96: '理财派息',
    report97: '请输入会员账号',
    report98: '买入理财',
    report99: '汇款总额',
    report100: '货币兑换出/入',
    report101: '委托兑换总额',
    report102: '提现提成',
    report103: '处理订单金额',
    report104: '异常值',
    report105: '正常',
    report106: '多收异常',
    report107: '少收异常',
    report108: '会员提现利润',
    report109: '会员汇款利润',
    report110: '会员兑换利润',
    report111: '幸运理财提成',
    report112: '对冲货币理财提成',
    report113: '直播礼物利润',
    report114: '利润总计',
    Exchange: '兑换',
    manager: '管理端修改',
    increaseLimit: '提额',
    payorderMER_FAULT: '故障完成',
    payOrder: '提成',
    payorderthirdMER_CANCEL: '第三方派单取消',

    cooperation1: '意向合作伙伴',
    cooperation2: '合作公司',
    cooperation3: '已读',
    cooperation4: '未读',
    cooperation5: '提交时间',
    cooperation6: '意向合作伙伴详情',
    cooperation7: '名',
    cooperation8: '姓',
    cooperation9: '邮箱地址',
    cooperation10: '外贸服务提供商',
    cooperation11: '年交易量',
    cooperation12: '手机号',
    cooperation13: '网站URL',
    cooperation14: '公司名称',
    cooperation16: '职位/部门',
    cooperation17: '低于100万美元',
    cooperation18: '100万-500万美元',
    cooperation19: '500万-1000万美元',
    cooperation20: '1000万美元以上',
    cooperation21: '是',
    cooperation22: '否',
    cooperation23: '意见/投诉',
    cooperation24: '联系方式',
    el: {
        colorpicker: {
            confirm: '确定',
            clear: '清空'
        },
        datepicker: {
            now: '此刻',
            today: '今天',
            cancel: '取消',
            clear: '清空',
            confirm: '确定',
            selectDate: '选择日期',
            selectTime: '选择时间',
            startDate: '开始日期',
            startTime: '开始时间',
            endDate: '结束日期',
            endTime: '结束时间',
            prevYear: '前一年',
            nextYear: '后一年',
            prevMonth: '上个月',
            nextMonth: '下个月',
            year: '年',
            month1: '1 月',
            month2: '2 月',
            month3: '3 月',
            month4: '4 月',
            month5: '5 月',
            month6: '6 月',
            month7: '7 月',
            month8: '8 月',
            month9: '9 月',
            month10: '10 月',
            month11: '11 月',
            month12: '12 月',
            // week: '周次',
            weeks: {
                sun: '日',
                mon: '一',
                tue: '二',
                wed: '三',
                thu: '四',
                fri: '五',
                sat: '六'
            },
            months: {
                jan: '一月',
                feb: '二月',
                mar: '三月',
                apr: '四月',
                may: '五月',
                jun: '六月',
                jul: '七月',
                aug: '八月',
                sep: '九月',
                oct: '十月',
                nov: '十一月',
                dec: '十二月'
            }
        },
        select: {
            loading: '加载中',
            noMatch: '无匹配数据',
            noData: '无数据',
            placeholder: '请选择'
        },
        cascader: {
            noMatch: '无匹配数据',
            loading: '加载中',
            placeholder: '请选择',
            noData: '暂无数据'
        },
        pagination: {
            goto: '前往',
            pagesize: '条/页',
            total: '共 {total} 条',
            pageClassifier: '页'
        },
        messagebox: {
            title: '提示',
            confirm: '确定',
            cancel: '取消',
            error: '输入的数据不合法!'
        },
        upload: {
            deleteTip: '按 delete 键可删除',
            delete: '删除',
            preview: '查看图片',
            continue: '继续上传'
        },
        table: {
            emptyText: '暂无数据',
            confirmFilter: '筛选',
            resetFilter: '重置',
            clearFilter: '全部',
            sumText: '合计'
        },
        tree: {
            emptyText: '暂无数据'
        },
        transfer: {
            noMatch: '无匹配数据',
            noData: '无数据',
            titles: ['列表 1', '列表 2'],
            filterPlaceholder: '请输入搜索内容',
            noCheckedFormat: '共 {total} 项',
            hasCheckedFormat: '已选 {checked}/{total} 项'
        },
        image: {
            error: '加载失败'
        },
        pageHeader: {
            title: '返回'
        },
        popconfirm: {
            confirmButtonText: '确定',
            cancelButtonText: '取消'
        }
    },

    addAnget: '添加代理',
    addMerAnget: '添加商户代理',
    addComAnget: '添加总公司',
    im1: '查询条件不能为空',
    im2: '申请成功,请等待对方通过',
    im3: '不能发送空消息',
    im4: '添加好友',
    im5: '已申请',
    im6: '加载失败',
    im7: '查询',
    im8: '账号',
    im9: '查找朋友',
    im10: '已通过',
    im11: '申请朋友',
    im12: '加载失败',
    im13: '暂无好友',
    im14: '新的好友',
    im15: '无聊天记录',
    im16: '[图片]',
    im17: '[语音]',
    im18: '无联系人',
    im19: '新的朋友',
    im20: '添加新朋友',
    im21: '搜索记录或账户名',
    im22: '申请流量额度出错，请联系集团公司',
    im23: '搜索',
    im24: '发起群聊',
    im25: '发送',
    im26: '请选择需要添加的联系人',
    im27: '群聊',
    im28: '权限不足',
    im29: '未设置流量购买费率，请联系集团公司',
    im30: '解散该群',
    im31: '是否解散该群?',
    im32: '解散成功',

    head1: '总公司流量购买审批记录',
    head2: '总公司累计购买流量总额',
    head3: '总公司本时段购买流量总额',
    head4: '全部总公司',
    head5: '新建总公司',
    head6: '总公司提现审批记录',
    head7: '总公司累计提现总额',
    head8: '总公司当日提现总额',
    head9: '提现总公司账户',
    head10: '申请人名称',
    head11: '总公司流量购买比例',
    head12: '用户信息',
    head13: '流量购入最少值为 1,000',

    //员工part2
    em1: '最近一次修改',
    em2: '修改人',
    em3: '审核',
    em4: '下级会员',
    //银行卡
    em5: '限额',
    em6: '流量控制银行卡',
    em7: '流量控制卡',
    //流量控制
    em8: '流量购买费率',

    parentCompany: {
        firstTitle: "集团公司后台管理",
        vipError: '有会员资金异常，请立即点击处理',
        subCompanyNumber: '分公司数量',
        headNumber: '总公司数量',
        agentNumber: '商代数量',
        merchantNumber: '商户数量',
        vipNumber: '会员数量',
        messageTip: 'IM消息提示',
        noMessage: '暂无消息',
        entrustRequest: '兑换请求审核',
        hasNewRequest: '您有新的用户兑换，请审批',
        noNewRequest: '暂无兑换请求',
        merchantAccessDetail: '商户入金流水',
        commission: '手续费',
        bonus: '提成费',
        systemRemit: '系统汇款',
        interestSum: '派息总额',
        payOrderWithdraw: '入金提现通知',
        hasNewAccessOrWithdraw: '您有新的用户入金/提现，请审批',
        NoNewAccessOrWithdraw: '暂无入金提现请求',
        merchantDetailSum: '流水总笔数',
        weChatNumber: '微信扫码流水',
        aliPayNumber: '支付宝扫码流水',
        bankNumber: '银行流水',
        cloudFlashNumber: '云闪付流水',
        freeSumNumber: '手续费笔数',
        freeMerchantNumber: '商户入金',
        freeRemitNumber: '汇款',
        freeEntrustNumber: '兑换',
        bonusSumNumber: '提成笔数',
        bonusWithDrawNumber: '提现提成',
        bonusRemitNumber: '汇款提成',
        bonusEntrustNumber: '兑换提成',
        bonusLuckyNumber: '幸运理财',
        systemRemitNumber: '交易笔数',
        remitNumber: '汇款',
        cashEntrustNumber: '现金兑换',
        chipEntrustNumber: '筹码兑换',
        virtualCoinNumber: '虚拟货币兑换',
        interestSumNumber: '派息次数',
        parentCompanyInterest: '集团公司派息',
        childCompanyInterest: '分公司派息',
        faultMessage: '故障单通知',
        faultMessageTip: '您有新的交易/汇款故障单，请处理',
        noFault: '暂无故障单',
        merchantTodayDetail: '商户本日入金流水',
        merchantSumDetail: '总入金流水',
        companyTodayProfit: '公司本日盈利',
        sumProfit: '总盈利',
        freezeDate: '冻结数据',
        sum: '共',
        bit: '笔',
        freezeMoney: '冻结金额',
        merchantAccessRequest: '商户提额申请',
        merchantAccessRequestTip: '您有新的商户/高级商户提额申请，请审批',
        noMerchantAccessRequest: '暂无商户提额申请',
        orderMessage: '订单消息',
        noOrder: '暂无订单',
        orderMessageTip: '产生了一笔新的订单，订单号为',
        IMMessageTip: '您有新的消息',

        popUpCurrName: '币别',
        popUpAmount: '金额',
        withdrawal: '提现',

        areaCode: '地区号'

    },
    subCompany: {
        vipError: '有会员资金异常，请立即点击处理',
        firstTitle: '公司后台管理',
        uid: '推广码',
        memberNumber: '会员数量',
        liuliang: '剩余流量',
        balance: '账户余额',
        imMessageTip: 'IM消息提示',
        noImMessage: '暂无消息',
        vipEntrustRemit: '会员兑换汇款',
        vipEntrustRemitTip: '您的会员有新的兑换/汇款，请查看',
        noEntrustRemit: '暂无兑换汇款请求',
        vipWithdrawDetail: '会员提现流水',
        commission: '手续费',
        bonus: '提成费',
        vipRemitEntrust: '会员汇款兑换',
        interestSum: '派息总额',
        billAccessNotify: '抢单充值通知',
        billAccessTip: '您有新的充值订单，请抢单',
        noBillAccess: '暂无入金提现请求',
        withdrawSum: '提现总笔数',
        weChatCode: '微信扫码',
        aliPayCode: '支付宝扫码',
        weChatCodeZan: '微信赞赏码',
        personalBank: '个人银行',
        enterBank: '企业银行',
        cloudFlashPay: '云闪付',
        sumNumber: '总笔数',
        vipRemit: '会员汇款',
        vipLegalEntrust: '会员货币兑换',
        vipCashEntrust: '会员现金兑换',
        vipChipEntrust: '会员筹码兑换',
        vipVirtualCoin: '会员虚拟货币兑换',
        balanceSumNumber: '总笔数',
        balanceWeChatCode: '微信扫码',
        balanceAliPayCode: '支付宝扫码',
        balanceWeChatCodeZan: '微信赞赏码',
        balancePersonalBank: '个人银行',
        balanceEnterBank: '企业银行',
        balanceCloudFlash: '云闪付',
        balanceLuckyMoney: '幸运理财',
        remitSumNumber: '总笔数',
        remitVipRemit: '会员汇款',
        remitVipCashEntrust: '会员现金兑换',
        remitVipChipEntrust: '会员筹码兑换',
        remitVipVirtualCoin: '会员虚拟货币兑换',
        vipTodayWithdrawDetail: '会员本日提现流水',
        sumOrderDetail: '总入金流水',
        companyToadyProfit: '公司本日盈利',
        sumProfit: '总盈利',
        faultNotify: '故障单通知',
        faultMessage: '您有新的交易/汇款故障单，请处理',
        noFault: '暂无故障单',
        vipLimitBalanceRequest: '会员提额申请',
        vipLimitBalanceMessage: '您有新的会员提额申请，请审批',
        noLimitBalance: '暂无会员提额申请',
        payOrder: '订单消息',
        noOrder: '暂无订单',
        orderMessageFormat: '会员({0}) 通过 [{1}] 提现了一笔 {2}{3} 的入金理财',
        faultRemitMessageFormat: '会员({0})有一笔汇款故障单,请处理',
        faultWithdrawMessageFormat: '会员({0})有一笔汇款故障单,请处理',
        imMessageContent: '您有新的消息',
        subcompany1: '分公司流量购买审批记录',
        subcompany2: '分公司累计购买流量总额',
        subcompany3: '分公司本时段购买流量总额',
        subcompany4: '账户流量',
        subcompany5: '选择购入货币',
        subcompany6: '请选择购买币种',
        subcompany7: '请加载支付资料',
        subcompany8: '汇出余额',
        subcompany9: '分公司提现审批记录',
        subcompany10: '分公司累计提现总额',
        subcompany11: '分公司当日提现总额',
        subcompany12: '提现分公司账户',
        remitBalance: '汇出余额',

    },
    subCompanyAgent: {
        firstTitle: '总公司后台管理',
        agentCompanyNumber: '分公司数量',
        balance: '账户余额',
        imMessageTip: 'IM消息提示',
        noMessage: '暂无消息',
        vipWithdrawDetail: '提现流水',
        commission: '手续费',
        bonus: '提成费',
        remitEntrust: '汇款兑换',
        orderSumNumber: '提现总笔数',
        orderWeChatNumber: '微信扫码',
        orderAliPayNumber: '支付宝扫码',
        orderWeChatCodeNumber: '微信赞赏码',
        orderPersonBankNumber: '个人银行',
        orderEnterBankNumber: '企业银行',
        orderCloudFlashNumber: '云闪付',
        freeSumNumber: '总笔数',
        freeRemitNumber: '汇款',
        freeLegalNumber: '货币兑换',
        freeCashNumber: '现金兑换',
        freeChipNumber: '会员筹码兑换',
        freeVirtualCoinNumber: '虚拟货币兑换',
        bonusSumNumber: '总笔数',
        bonusVipOrder: '会员提现',
        bonusVipRemit: '会员汇款',
        bonusLegalEntrust: '货币兑换',
        bonusEntrust: '委托兑换',
        bonusLuckyMoney: '幸运理财',
        remitSumNumber: '总笔数',
        remitVipRemit: '汇款',
        remitCashRemit: '现金兑换',
        remitChipRemit: '筹码兑换',
        remitVirtualCoinRemit: '虚拟货币兑换',
        todayCompanyWithdrawDetail: '本日旗下公司提现流水',
        withdrawDetail: '总提现流水',
        todayProfit: '本日盈利',
        sumProfit: '总盈利',
        payOrder: '提现订单',
        noBill: '暂无订单',
        orderMessageFormat: '{0} 公司产生了一笔提现订单',
        imMessageContent: '您有新的消息'
    },
    firstMerchant: {
        firstTitle: '商户后台管理',
        limitBalance: '账户额度',
        financialBalance: '理财总额',
        balance: '账户余额',
        vipOrderDetail: '入金流水',
        commission: '手续费',
        remitEntrust: '汇款兑换',
        interestSum: '计息总额',
        vipOrderTotalNumber: '提现总笔数',
        vipOrderWeChatCode: '微信扫码',
        vipOrderAliPayCode: '支付宝扫码',
        vipOrderPersonBank: '个人银行',
        cloudFlashNumber: '云闪付',
        freeTotalNumber: '总笔数',
        freeAccessNumber: '理财入金',
        freeRemitNumber: '汇款',
        freeLegalNumber: '货币兑换',
        freeEntrustNumber: '委托兑换',
        bonusTotalNumber: '总笔数',
        bonusWeChatCode: '微信扫码',
        bonusAliPayCode: '支付宝扫码',
        bonusWeChatZanCode: '微信赞赏码',
        bonusPersonBankCode: '个人银行',
        bonusEnterBankCode: '企业银行',
        bonusCloudFlashCode: '云闪付',
        bonusLuckyMoneyCode: '幸运理财',
        remitTotalNumber: '总笔数',
        remitAccessNumber: '理财入金',
        remitRemitNumber: '汇款',
        remitLegalNumber: '货币兑换',
        remitEntrustNumber: '委托兑换',
        todayOrder: '本日入金',
        todayOrderSum: '总入金流水',
        todayFree: '本日费率',
        todayFreeSum: '总费率',
        faultNotify: '故障单通知',
        noFault: '暂无故障单',
        imMessageTitle: 'IM消息提示',
        noIMMessage: '暂无消息',
        orderMessage: '订单消息',
        noOrder: '暂无订单',
        imMessageContent: '您有新的消息',
        orderMessageFormat: '您有一笔通过 [{0}] 购买的 {1}{2} 的入金理财',
        remitFaultMessageFormat: '您有一笔汇款故障单,请处理',
        orderFaultMessageFormat: '您有一笔入金故障单,请处理',
    },
    firstMerchantAgent: {
        firstTitle: '商户代理后台管理',
        merchantNumber: '商户数量',
        balanceNumber: '账户余额',
        imMessageTitle: 'IM消息提示',
        noIMMessage: '暂无消息',
        vipOrderAccessNumber: '入金流水',
        commission: '手续费',
        bonus: '提成费',
        remitEntrust: '汇款兑换',
        vipOrderTotal: '提现总笔数',
        vipOrderWeChatCode: '微信扫码',
        vipOrderAliPayCode: '支付宝扫码',
        vipPersonBankCode: '个人银行',
        vipCloudFlashCode: '云闪付',
        freeTotalNumber: '总笔数',
        freeRemit: '汇款',
        freeRemitEntrust: '货币兑换',
        freeCashEntrust: '现金兑换',
        freeChipEntrust: '筹码兑换',
        freeVirtualCoinEntrust: '虚拟货币兑换',
        bonusTotalNumber: '总笔数',
        bonusPayOrder: '商户入金',
        bonusRemitNumber: '商户汇款',
        bonusRemitLegalNumber: '商户货币兑换',
        bonusEntrustNumber: '商户委托兑换',
        bonusSumNumber: '总笔数',
        bonusRemitVipNumber: '汇款',
        bonusEntrustLegalNumber: '货币兑换',
        bonusCashLegalNumber: '现金兑换',
        bonusChipLegalNumber: '筹码兑换',
        bonusVirtualCoinNumber: '虚拟货币兑换',
        todayMerchantAccessDetail: '本日旗下商户入金流水',
        sumAccessDetail: '总入金流水',
        todayProfit: '本日盈利',
        sumProfit: '总盈利',
        orderMessage: '订单消息',
        noOrder: '暂无订单',
        orderVVIPMessageFormat: "{0} 高级会员产生了一笔入金订单",
        orderMerchantMessageFormat: "{0} 商户产生了一笔入金订单",
        imMessageContent: '您有新的消息',
        faultRemitMessageFormat: '您有一笔汇款故障单,请处理',
        faultOrderMessageFormat: '您有一笔入金故障单,请处理',
    },
    agentCustomerStatisticsReport: {
        customerName: '客户名',
        sumNumber: '笔数',
        money: '金额'
    },
    chat1: '新建群聊',
    chat2: '完成',
    chat3: '选择群组',
    chat4: '选择群聊',
    chat5: '群聊信息',
    chat6: '群聊名称',
    chat7: '清空聊天记录',
    chat8: '删除并退出',
    chat9: '群名修改',
    chat10: '请输入群聊名称',
    chat11: '用户账号',
    chat12: '朋友圈',
    chat13: '添加到通讯录',
    chat14: '选择成员',
    chat15: '暂无好友可以添加',
    chat16: '是否删除并退出?',
    chat17: '已将',
    chat18: '移出群聊',
    chat19: '你已将',
    chat20: '邀请',
    chat21: '加入群聊',
    chat22: '你邀请',
    chat23: '退出群聊',
    chat24: '你已被移出群聊',
    chat25: '你',
    chat26: '修改群昵称为',
    chat27: '聊天',
    chat28: '通讯录',
    chat29: '发消息',
    chat30: '用户账号',
    chat31: '进入群聊',
    chat32: '群聊名称',
    chat33: '你们已经是好友了，快来一起聊天吧',
    chat34: '点击添加备注',
    chat35: '备注',
    chat36: '设置备注失败，请重新设置',

    paypal1: 'Paypal账号',
    paypal2: 'Paypal邮箱',
    paypal3: 'Paypal二维码',
    paypal4: '请输入Paypal账号',
    paypal5: '请输入Paypal邮箱',
    paypal6: '请选择Paypal二维码',
    paypal7: 'PayPal支付',
    theChannel: {
        channel1: '通道类型',
        channel2: '支付类型',
        channel3: '通道图标',
        channel4: '新建通道',
        channel5: '手续费最小值',
        channel6: '提成最小值',
        channel7: '适用群体',
        channel8: '最大率',
        channel9: '通道类型(英文)',
        channel10: '通道类型(繁体)',
        channel11: '通道类型(日文)',
        channel12: '通道类型(韩文)',
        channel13: '图标大小不能超过2kb',
        channel14: '请将通道信息补充完整',
        channel15: '手续费最小值不能大于最大率',
        channel16: '提成最小值不能大于最大率',
        channel17: '修改通道信息',
        channel18: '修改通道状态失败',
        channel19: '修改通道状态成功',
        channel20: '步进值',
        channel21: '最大率不能小于0',
        channel22: '手续费最小值不能小于0',
        channel23: '提成最小值不能小于0',
        channel24: '步进值不能小于0',
        channel25: '请输入通道名称',
    },
    present: {
        presentName: '礼物名称',
        presentImage: '礼物图片',
        presentCurrency: '礼物币别',
        presentCost: '礼物价格',
        enterPresentName: '请输入礼物名称',
        newPresent: '新建礼物',
        presentEn: '礼物名称(英语)',
        presentTr: '礼物名称(繁体)',
        presentJa: '礼物名称(日语)',
        presentKr: '礼物名称(韩语)',
        editPresent: '修改礼物信息',
        completeInfo: '请将礼物信息补充完整',
        limit: '图片大小不能超过',
        AmoutErr: '礼物价格不能为负数',
    },

    anchorCom: {
        anchorCompany: '直播公司',
        number: '公司个数',
        most: '招募主播最多',
        highest: '直播收入最高',
        name: '公司名称',
        anchors: '旗下主播',
        living: '直播中',
        giftAmount: '礼物总额',
        new: '新建直播公司',
        companyStatus: '公司状态',
        enterName: '请输入公司名称',
        account: '公司账号',
        companyName: '公司名称',
        edit: '修改直播公司资料',
        returnsRate: '收益提成率',
        flowRecord: '流量购买审批记录',
        flowTotal: '累计购买流量总额',
        flowCurTot: '本时段购买流量总额',
        withdrawalRecord: '直播公司提现审批记录',
        withdrawalTotal: '直播公司累计提现总额',
        withdrawalCurTot: '直播公司本时段提现总额',
        anchorsNum: '主播数量',
        homeTitle: '直播公司后台管理',
        mustAccount: '直播公司账号不能为空',
        mustName: '直播公司名称不能为空',
        digital1: '主播数字货币充值记录',
        digital2: '主播累计充值总额',
        digital3: '主播当天充值总额',
        //companuName:'直播公司名称',


    },
    zhubo: {
        anchor: '主播',
        numofLiving: '直播中个数',
        mostGifted: '礼物收取最高',
        anchorStatu: '用户状态',
        followers: '粉丝总数',
        new: '新建主播',
        type: '主播类型',
        liveAnchor: '直播主播',
        interactionAnchor: '互动主播',
        account: '主播账号',
        name: '主播名称',
        plsSelectType: '请选择主播类型',
        flowRecord: '主播流量购买审批记录',
        flowTotal: '主播累计购买流量总额',
        flowCurTot: '主播本时段购买流量总额',
        enterName: '请输入主播名称',
        edit: '修改主播资料',
        rate: '主播费率',
        plsEnterAct: '主播账号不能为空',
        plsEnterName: '主播名称不能为空',
        maximumRecharge: '充值单笔最大',
        rechargeCharge: '充值手续费',
        fansNum: '粉丝数量',
        toTop: '置顶',
        fanschange: '粉丝数修改',
        plsFans: '请输入粉丝数量',
        changeFans: '是否修改该主播的粉丝数量?',
        topAnchor: '是否置顶该主播?',
        unTopAnchor: '是否取消置顶该主播?',
    },

    giftRecord1: '礼物消费总额',
    giftRecord2: '消费最高会员',
    giftRecord3: '礼物类型',
    giftRecord4: '礼物数量',
    giftRecord5: '收礼主播',
    giftRecord6: '请输入会员名称或订单号',
    giftRecord7: '交易类型',
    giftRecord8: '打赏主播',
    giftRecord9: '礼物消费',

    anchorCompany: '直播公司',
    sexAnchor: '互动主播',
    liveAnchor: '直播主播',

    merchantAgent1: '商代流量购买审批记录',
    merchantAgent2: '商代累计购买流量总额',
    merchantAgent3: '商代本时段购买流量总额',
    merchantAgent4: '商代账号',
    merchantAgent5: '请输入商代名称',

    digital1: '数字货币充值记录',
    digital2: '累计充值总额',
    digital3: '当天充值总额',
    digital4: '数字货币充值',
    digital5: '充值数字货币',
    digital6: '数字货币金额',
    digital7: '充值货币',
    digital8: '数字货币金额',
    digital9: '选择数字货币',
    digital10: '链名称通道',
    digital11: '数字货币名称',
    digital12: '交易平台',
    digital13: '收款钱包地址',
    digital14: '转账数量',
    digital15: '收款二维码',
    digital16: '数字货币充值详情',
    digital17: '请选择数字货币',
    digital18: '请选择充值货币',
    digital19: '充值成功',
    digital20: '请输入正确的汇率',
    digital21: '数字货币充值收款通道',

    shortVideo1: '播放次数',
    shortVideo2: '点赞数量',
    shortVideo3: '评论数量',
    shortVideo4: '分享次数',
    shortVideo5: '上传时间',
    shortVideo6: '查看视频',
    shortVideo7: '置顶',
    shortVideo8: '取消置顶',
    shortVideo9: '编辑视频资料',
    shortVideo10: '在线短视频数量',
    shortVideo11: '请将短视频信息补充完整',
    shortVideo12: '播放次数必须大于等于0次',
    shortVideo13: '点赞数量必须大于等于0次',
    shortVideo14: '评论数量必须大于等于0次',
    shortVideo15: '分享次数必须大于等于0次',
    shortVideo16: '短视频预览',
    shortVideo17: '点击查看视频',

    livingRoom1: '直播房间数',
    livingRoom2: '房间号',
    livingRoom3: '观看人数',
    livingRoom4: '直播礼物',
    livingRoom5: '请输入用户名称/账号',
    livingRoom6: '请输入房间号',
    livingRoom7: '强制下播',
    livingRoom8: '确定强制下播该房间？',
    livingRoom9: '修改观看人数',
    livingRoom10: '观看人数不能为负数',
    livingRoom11: '观看人数不能为空',
    ad: {
        addAd: '新增广告',
        adTitle: '广告标题',
        adUrl: '广告图片',
        jumpUrl: '跳转链接',
        adUrlTip: '请上传广告图片',
        adCountTip: '广告条数已经用完，请删除再创建',
        isdeleAd: '是否删除这条广告',
        updateAdTitle: '修改广告',
    },
    notification: {
        addNotificationTitle: '新建公告',
        updateNotificationTitle: '修改公告',
        notificationContent: '公告内容',
        notificationTitle: '公告标题',
        tip: '请输入公告标题/公告内容',
        isDelectNotification: '是否删除这条公告'
    },
    userManage: {
        userManage1: '会员个数',
        userManage2: '推广最多',
        userManage3: '普通会员',
        userManage4: '平台交易员',
        userManage5: 'OTC运营商',
        userManage6: '待审核',
        userManage7: '已审核',
        userManage8: '申请升级',
        userManage9: '推广人数',
        userManage10: '交易员审核',
        userManage11: '会员填写信息',
        userManage12: '系统读取信息',
        userManage13: '真实姓名',
        userManage14: '所在国家',
        userManage15: '主要交易货币',
        userManage16: '用户主货币',
        userManage17: '所在州/省',
        userManage18: '所在城市',
        userManage19: '验证手机号码',
        userManage20: '系统读取国家',
        userManage21: '系统读取州/省',
        userManage22: '系统读取城市',
        userManage23: '服务费',
        userManage24: '定额账号充值',
        userManage25: '现金交易充值',
        userManage26: '法定货币提现',
        userManage27: '现金交易手续费',
        userManage28: '转账汇款手续费',
        userManage29: '货币兑换手续费',
        userManage30: '转账汇款服务费',
        userManage31: '通道余额',
        userManage32: '通道限额',
        userManage33: '空闲',
        userManage34: '交易中',
    },
    order: {
        status: {
            ROBBING: '待接单',
            WAIT_REMIT: '等待转账',
            WAIT_PAY: '等待支付',
            WAIT_CONFIRM: '等待确认',
            PENDING: '等待审核',
            SUCCESS: '订单完成',
            REJECTED: '驳回',
            CANCEL: '已取消'
        }
    }
}
